import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchContactDetails } from '../../services/api';
import { FaEnvelope, FaPhone, FaMobileAlt, FaMapMarkerAlt, FaLocationArrow } from 'react-icons/fa';

const Footer = () => {
  const [contactDetails, setContactDetails] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchContactDetails();
        if (data.contacts && data.contacts.length > 0) {
          setContactDetails(data.contacts[0]);
        }
      } catch (error) {
        console.error('Error fetching contact details:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <h3 className="text-lg font-semibold mb-3">About Us</h3>
            <p className="text-gray-300 text-sm">
              Innovative Eco Krishi is dedicated to sustainable agriculture and environmental conservation.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/suggestion" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Suggestion
                </Link>
              </li>
            </ul>
          </div>
          {contactDetails && (
            <div>
              <h3 className="text-lg font-semibold mb-3">Contact</h3>
              <ul className="space-y-2 text-gray-300">
                {contactDetails.email && (
                  <li className="flex items-center space-x-2 group">
                    <FaEnvelope className="w-4 h-4 text-green-400 group-hover:text-green-300 transition-colors duration-200" />
                    <a href={`mailto:${contactDetails.email}`} className="text-sm hover:text-white transition-colors duration-200">
                      {contactDetails.email}
                    </a>
                  </li>
                )}
                {contactDetails.phone && (
                  <li className="flex items-center space-x-2 group">
                    <FaPhone className="w-4 h-4 text-green-400 group-hover:text-green-300 transition-colors duration-200" />
                    <a href={`tel:${contactDetails.phone}`} className="text-sm hover:text-white transition-colors duration-200">
                      {contactDetails.phone}
                    </a>
                  </li>
                )}
                {contactDetails.mobile && (
                  <li className="flex items-center space-x-2 group">
                    <FaMobileAlt className="w-4 h-4 text-green-400 group-hover:text-green-300 transition-colors duration-200" />
                    <a href={`tel:${contactDetails.mobile}`} className="text-sm hover:text-white transition-colors duration-200">
                      {contactDetails.mobile}
                    </a>
                  </li>
                )}
                {contactDetails.address && (
                  <li className="flex items-center space-x-2 group">
                    <FaMapMarkerAlt className="w-4 h-4 text-green-400 group-hover:text-green-300 transition-colors duration-200" />
                    <span className="text-sm">{contactDetails.address}</span>
                  </li>
                )}
                {contactDetails.location && (
                  <li className="flex items-center space-x-2 group">
                    <FaLocationArrow className="w-4 h-4 text-green-400 group-hover:text-green-300 transition-colors duration-200" />
                    <span className="text-sm">{contactDetails.location}</span>
                  </li>
                )}
              </ul>
            </div>
          )}
          <div>
            <h3 className="text-lg font-semibold mb-3">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://www.tiktok.com/@innovative_krishi" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors duration-200">
                <span className="sr-only">TikTok</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </a>
              <a href="https://www.youtube.com/@innovativekrishi" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors duration-200">
                <span className="sr-only">YouTube</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-6 border-t border-gray-700 pt-6">
          <p className="text-center text-gray-300 text-sm">
            © {new Date().getFullYear()} Innovative Eco Krishi. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 